// 📁 Fichier 1 : src/environments/environment.ts
export const environment = {
  production: false,

  // API Pointage - URLs principales (même URL que production pour éviter localhost:4200)
  apiBaseUrl: 'https://innov.sn/pointage',
  apiUrl: 'https://innov.sn/pointage/api',
  apiUrlAddress: 'https://innov.sn/pointage/api/pointing-addresses',

  // URLs pour les fichiers
  filebaseUrl: 'https://btpconnect.app/repertoire_chantier/',
  filesUrl: 'https://innov.sn/repertoire_u/',

  // Couleurs du thème
  theme: {
    primaryColor: '#28396C',
    primaryLight: '#3D4F85',
    primaryDark: '#1A2748',
    secondaryColor: '#FF6B35',
    backgroundColor: '#F8F9FA',
    textColor: '#1A1A1A',
    borderColor: '#E0E0E0',
    successColor: '#28A745',
    errorColor: '#DC3545',
    warningColor: '#FFC107'
  },

  // Endpoints API avec URLs complètes
  endpoints: {
    // Authentification (API Pointage)
    auth: {
      signin: 'https://innov.sn/pointage/api/v1/auth/signin',
      signup: 'https://innov.sn/pointage/api/v1/auth/signup',
      refresh: 'https://innov.sn/pointage/api/v1/auth/refresh',
      changePassword: 'https://innov.sn/pointage/api/v1/auth/cahnge-password',
      resetPassword: 'https://innov.sn/pointage/api/v1/auth/password/reset'
    },

    // Utilisateurs (API Pointage)
    user: {
      me: 'https://innov.sn/pointage/api/v1/user/me',
      byId: 'https://innov.sn/pointage/api/v1/user/{id}',
      update: 'https://innov.sn/pointage/api/v1/user/update/{id}',
      delete: 'https://innov.sn/pointage/api/v1/user/{id}',
      changeProfil: 'https://innov.sn/pointage/api/v1/user/{userId}/change-profil',
      search: 'https://innov.sn/pointage/api/v1/user/search',
      byProfil: 'https://innov.sn/pointage/api/v1/user/by-profil',
      profilDistribution: 'https://innov.sn/pointage/api/v1/user/profil-distribution'
    },

    // Projets/RealEstate (API Pointage)
    realestate: {
      searchByPromoter: 'https://innov.sn/pointage/api/realestate/search-by-promoter',
      save: 'https://innov.sn/pointage/api/realestate/save',
      update: 'https://innov.sn/pointage/api/realestate/update/{id}',
      details: 'https://innov.sn/pointage/api/realestate/details/{id}',
      delete: 'https://innov.sn/pointage/api/realestate/delete/{id}'
    },

    // Salariés/Workers (API Pointage)
    workers: {
      all: 'https://innov.sn/pointage/api/workers',
      byProperty: 'https://innov.sn/pointage/api/workers/property/{propertyId}',
      save: 'https://innov.sn/pointage/api/workers/save/{propertyId}',
      create: 'https://innov.sn/pointage/api/workers/create/{managerId}',
      presenceHistory: 'https://innov.sn/pointage/api/workers/{workerId}/presence-history',
      check: 'https://innov.sn/pointage/api/workers/{workerId}/check',
      monthlySummary: 'https://innov.sn/pointage/api/workers/{workerId}/monthly-summary',
      dashboard: 'https://innov.sn/pointage/api/workers/{workerId}/mobile/dashboard',
      linkToProperty: 'https://innov.sn/pointage/api/workers/{propertyId}/workers/{userId}',
      teamOthers: 'https://innov.sn/pointage/api/workers/{managerId}/team/others',
      suppliers: 'https://innov.sn/pointage/api/workers/{managerId}/suppliers',
      subcontractors: 'https://innov.sn/pointage/api/workers/{managerId}/subcontractors',
      presenceRate: 'https://innov.sn/pointage/api/workers/manager/{managerId}/presence-rate'
    },

    // Adresses de pointage (API Pointage)
    pointingAddresses: {
      list: 'https://innov.sn/pointage/api/pointing-addresses',
      byProperty: 'https://innov.sn/pointage/api/pointing-addresses/property/{propertyId}',
      byId: 'https://innov.sn/pointage/api/pointing-addresses/{id}',
      create: 'https://innov.sn/pointage/api/pointing-addresses',
      update: 'https://innov.sn/pointage/api/pointing-addresses/{id}',
      delete: 'https://innov.sn/pointage/api/pointing-addresses/{id}'
    },

    // Tâches (API Pointage)
    tasks: {
      create: 'https://innov.sn/pointage/api/tasks',
      byId: 'https://innov.sn/pointage/api/tasks/{id}',
      update: 'https://innov.sn/pointage/api/tasks/{id}',
      delete: 'https://innov.sn/pointage/api/tasks/{id}',
      updateStatus: 'https://innov.sn/pointage/api/tasks/{id}/status',
      byProperty: 'https://innov.sn/pointage/api/tasks/by-property/{propertyId}',
      byExecutor: 'https://innov.sn/pointage/api/tasks/by-executor/{executorId}',
      addDocument: 'https://innov.sn/pointage/api/tasks/{taskId}/documents',
      deleteDocument: 'https://innov.sn/pointage/api/tasks/documents/{documentId}',
      dashboard: 'https://innov.sn/pointage/api/tasks/dashboard/mobile/{executorId}',
      kpis: 'https://innov.sn/pointage/api/tasks/kpis',
      statusDistribution: 'https://innov.sn/pointage/api/tasks/status-distribution/{executorId}',
      critical: 'https://innov.sn/pointage/api/tasks/critical',
      lateCount: 'https://innov.sn/pointage/api/tasks/late/count'
    },

    // Types de propriétés (API Pointage)
    propertyTypes: {
      all: 'https://innov.sn/pointage/api/property-types/all',
      byId: 'https://innov.sn/pointage/api/property-types/{id}',
      create: 'https://innov.sn/pointage/api/property-types/save',
      update: 'https://innov.sn/pointage/api/property-types/{id}',
      delete: 'https://innov.sn/pointage/api/property-types/{id}'
    },

    // QR Code (API Pointage)
    qrcode: {
      generate: 'https://innov.sn/pointage/api/qrcode/generate',
      decode: 'https://innov.sn/pointage/api/qrcode/decode'
    },

    // Attendance Report (API Pointage)
    attendance: {
      report: 'https://innov.sn/pointage/api/v1/attendance/real-estates/{propertyId}/report'
    },

    // Congés (API Pointage)
    leaves: {
      byProperty: 'https://innov.sn/pointage/api/v1/real-estates/{realEstateId}/leaves/requests',
      create: 'https://innov.sn/pointage/api/v1/real-estates/{realEstateId}/leaves/requests',
      review: 'https://innov.sn/pointage/api/v1/real-estates/{realEstateId}/leaves/requests/{requestId}/review',
      workerSummary: 'https://innov.sn/pointage/api/v1/real-estates/{realEstateId}/leaves/workers/{workerId}/summary'
    },

    // Souscriptions (API Pointage)
    subscriptions: {
      all: 'https://innov.sn/pointage/api/subscriptions',
      user: 'https://innov.sn/pointage/api/subscriptions/user/{userId}',
      create: 'https://innov.sn/pointage/api/subscriptions/create/{userId}/{planId}/{months}',
      invoices: 'https://innov.sn/pointage/api/subscriptions/invoices/{userId}',
      invoicesLatest: 'https://innov.sn/pointage/api/subscriptions/invoices-lastest',
      isActive: 'https://innov.sn/pointage/api/subscriptions/is-active/{userId}',
      canCreateProject: 'https://innov.sn/pointage/api/subscriptions/can-create-project/{userId}',
      dashboard: 'https://innov.sn/pointage/api/subscriptions/dashbord',
      evolution: 'https://innov.sn/pointage/api/subscriptions/evolution',
      revenueEvolution: 'https://innov.sn/pointage/api/subscriptions/revenues/evolution',
      planDistribution: 'https://innov.sn/pointage/api/subscriptions/plan-distribution'
    },

    // Plans de souscription (API Pointage)
    subscriptionPlans: {
      all: 'https://innov.sn/pointage/api/subscription-plans',
      byId: 'https://innov.sn/pointage/api/subscription-plans/{id}',
      byName: 'https://innov.sn/pointage/api/subscription-plans/name/{name}',
      create: 'https://innov.sn/pointage/api/subscription-plans',
      update: 'https://innov.sn/pointage/api/subscription-plans/{id}',
      delete: 'https://innov.sn/pointage/api/subscription-plans/{id}'
    },

    // Endpoints supplémentaires pour compatibilité
    projects: 'https://innov.sn/pointage/api/realestate',
    indicators: 'https://innov.sn/pointage/api/indicators/global',
    budgets: 'https://innov.sn/pointage/api/budgets',
    materials: 'https://innov.sn/pointage/api/materials',
    incidents: 'https://innov.sn/pointage/api/incidents',
    progressAlbum: 'https://innov.sn/pointage/api/progress-album',
    promoters: 'https://innov.sn/pointage/api/users/promoters',
    save: 'https://innov.sn/pointage/api/realestate/save',
    videoPromo: 'https://innov.sn/pointage/api/video-promo'
  }
};